{
  "AGENT_BOTS": {
    "HEADER": "Боти",
    "LOADING_EDITOR": "Завантаження редактора...",
    "DESCRIPTION": "Agent Bots are like the most fabulous members of your team. They can handle the small stuff, so you can focus on the stuff that matters. Give them a try.You can manage your bots from this page or create new ones using the 'Configure new bot' button.",
    "LEARN_MORE": "Learn about agent bots",
    "CSML_BOT_EDITOR": {
      "NAME": {
        "LABEL": "Ім'я бота",
        "PLACEHOLDER": "Дайте ім'я вашому боту.",
        "ERROR": "Ім'я бота обов'язкове."
      },
      "DESCRIPTION": {
        "LABEL": "Опис бота",
        "PLACEHOLDER": "Що робить цей бот?"
      },
      "BOT_CONFIG": {
        "ERROR": "Будь ласка, введіть вище CSML конфігурацію бота.",
        "API_ERROR": "Ваша конфігурація CSML недійсна, будь ласка, виправте її та повторіть спробу."
      },
      "SUBMIT": "Перевірити і зберегти"
    },
    "BOT_CONFIGURATION": {
      "TITLE": "Виберіть агента - бота",
      "DESC": "Призначте Agent Bot для вашої папки \"Вхідні\". Вони можуть обробляти початкові розмови та передавати їх живому агенту, за необхідності.",
      "SUBMIT": "Оновити",
      "DISCONNECT": "Від'єднати бота",
      "SUCCESS_MESSAGE": "Успішно оновлено бота агента.",
      "DISCONNECTED_SUCCESS_MESSAGE": "Бот агента успішно відключений.",
      "ERROR_MESSAGE": "Не вдалося оновити бота агента. Будь ласка, спробуйте ще раз.",
      "DISCONNECTED_ERROR_MESSAGE": "Не вдалося відключити бота. Будь ласка, спробуйте ще раз.",
      "SELECT_PLACEHOLDER": "Виберіть бота",
      "OPTION": "{name} ({description})",
      "COUNTRY_BOTS": {
        "TITLE": "Боти за країнами",
        "DESC": "Ця скринька обслуговує кілька країн. Діалог потрапляє до бота своєї країни: за магазином Kaufland, за маркетплейсом замовлення Allegro, а інакше за мовою, якою пише покупець. Усі інші діалоги потрапляють до бота за замовчуванням вище.",
        "COUNTRY": "Виберіть країну",
        "BOT": "Виберіть бота",
        "ADD": "Додати бота для країни",
        "REMOVE": "Видалити",
        "DEFAULT_REQUIRED": "Спочатку виберіть бота за замовчуванням. Бот країни замінює його лише для цієї країни.",
        "DISCONNECT_ALL": "Від'єднати всіх ботів"
      }
    },
    "ADD": {
      "TITLE": "Налаштувати нового бота",
      "CANCEL_BUTTON_TEXT": "Скасувати",
      "API": {
        "SUCCESS_MESSAGE": "Бота успішно додано.",
        "ERROR_MESSAGE": "Не вдалося додати бота. Будь ласка, спробуйте ще раз пізніше."
      }
    },
    "LIST": {
      "404": "Ботів не знайдено. Ви можете створити бота, натиснувши кнопку 'Налаштувати нового бота' ↗️",
      "LOADING": "Отримання ботів...",
      "TYPE": "Тип бота",
      "TABLE_HEADER": {
        "DETAILS": "Деталі бота",
        "URL": "URL webhook"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Видалити",
      "TITLE": "Видалити бота",
      "SUBMIT": "Видалити",
      "CANCEL_BUTTON_TEXT": "Скасувати",
      "DESCRIPTION": "Ви впевнені, що хочете видалити цього бота? Ця дія є незворотньою.",
      "API": {
        "SUCCESS_MESSAGE": "Бот успішно видалений.",
        "ERROR_MESSAGE": "Не вдалося видалити бота. Будь ласка, спробуйте ще раз."
      },
      "CONFIRM": {
        "TITLE": "Підтвердження видалення",
        "MESSAGE": "Ви впевнені, що хочете видалити {name}?",
        "YES": "Так, видалити",
        "NO": "Ні, залишити"
      }
    },
    "EDIT": {
      "BUTTON_TEXT": "Редагувати",
      "LOADING": "Отримання ботів...",
      "TITLE": "Редагувати бота",
      "CANCEL_BUTTON_TEXT": "Скасувати",
      "API": {
        "SUCCESS_MESSAGE": "Бот успішно оновлений.",
        "ERROR_MESSAGE": "Не вдалося оновити бота. Будь ласка, спробуйте ще раз."
      }
    },
    "TYPES": {
      "WEBHOOK": "Webhook Бот",
      "CSML": "CSML Бот"
    },
    "GLOBAL_BOT": "Системний бот",
    "GLOBAL_BOT_BADGE": "Системний",
    "AVATAR": {
      "SUCCESS_DELETE": "Аватар бота успішно видалено",
      "ERROR_DELETE": "Помилка видалення аватара бота, будь ласка, спробуйте ще раз"
    },
    "FORM": {
      "AVATAR": {
        "LABEL": "Аватар бота"
      },
      "NAME": {
        "LABEL": "Назва бота",
        "PLACEHOLDER": "Введіть назву бота",
        "REQUIRED": "Назва бота обов'язкова"
      },
      "DESCRIPTION": {
        "LABEL": "Опис",
        "PLACEHOLDER": "Що робить цей бот?"
      },
      "WEBHOOK_URL": {
        "LABEL": "URL webhook",
        "PLACEHOLDER": "https://example.com/webhook",
        "REQUIRED": "URL webhook обов'язковий"
      },
      "ERRORS": {
        "NAME": "Назва бота обов'язкова",
        "URL": "URL webhook обов'язковий",
        "VALID_URL": "Будь ласка, введіть дійсний URL, що починається з http:// або https://"
      },
      "CANCEL": "Скасувати",
      "CREATE": "Створити бота",
      "UPDATE": "Оновити бота"
    },
    "WEBHOOK": {
      "DESCRIPTION": "Налаштуйте webhook-бота для інтеграції з вашими сервісами. Бот отримуватиме та оброблятиме події з розмов і може на них відповідати."
    }
  }
}
